import { createClient } from '@supabase/supabase-js'
import type { Database } from './types'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    'Brak zmiennych VITE_SUPABASE_URL lub VITE_SUPABASE_ANON_KEY. ' +
    'Ustaw je w pliku .env.local.'
  )
}

export const supabase = createClient<Database>(
  supabaseUrl ?? '',
  supabaseAnonKey ?? '',
  {
    auth: {
      // Wyłącz navigator.locks — powoduje deadlock z Vercel Preview Toolbar
      lock: (_name, _acquireTimeout, fn) => fn(),
    },
  },
)
